/* WFW EXPRESS NAV START */
(function () {
  'use strict';

  if (document.documentElement.classList.contains('h-ab-live')) return;

  var PIN_KEY = 'ExistPincode';
  var TOGGLE_KEY = 'WfwExpressOn';
  var CACHE_PREFIX = 'WfwExpressEligible:v2:';
  var EXPRESS_PATH = '/collections/w-express-delivery';

  var EXPRESS_BUTTONS = {
    header: 'Header Pincode Fill',
    toggle: 'Header Filter Toggle',
    bottom_nav: 'Bottom Nav. Landing Page',
    menu: 'Menu Slide Landing Page',
    collection_pin: 'CLP Pincode Box',
    product_pin: 'PDP Pincode Box'
  };

  function whenExpressTrackReady(done) {
    function ready() {
      return !!(
        window.HeliumUtils &&
        window.HeliumUtils.tracking &&
        window.HeliumUtils.tracking.feature &&
        typeof window.HeliumUtils.tracking.feature.triggered === 'function'
      );
    }
    if (ready()) {
      done();
      return;
    }
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (ready() || tries > 40) {
        clearInterval(timer);
        done();
      }
    }, 250);
  }

  function trackExpress(step, extra) {
    var surface = extra && extra.surface;
    var saved = !!storedPin();
    var strategy = '';
    var tags = null;
    if (step === 'variant_tagged') {
      tags = { name: 'w_express', id: 'variant_tagged' };
    } else {
      if (step === 'user') strategy = saved ? 'saved-user' : 'unsaved-user';
      else strategy = EXPRESS_BUTTONS[surface] || '';
      if (!strategy) return;
      tags = {
        name: 'w_express',
        id: strategy,
        strategyId: strategy,
        variant: saved ? 'saved' : 'unsaved'
      };
    }
    var payload = { did_render: true };
    if (extra) {
      Object.keys(extra).forEach(function (key) {
        if (key === 'pinState' || key === 'surface') return;
        payload[key] = extra[key];
      });
    }
    whenExpressTrackReady(function () {
      try {
        var feature = window.HeliumUtils.tracking.feature;
        if (!feature || typeof feature.triggered !== 'function') return;
        feature.triggered(tags, payload);
      } catch (e) {}
    });
  }

  function storedPin() {
    try {
      var pin = localStorage.getItem(PIN_KEY) || '';
      return /^\d{6}$/.test(pin) ? pin : '';
    } catch (e) {
      return '';
    }
  }

  window.WfwExpressTrack = {
    event: trackExpress,
    pin: function (pin, surface) {
      var next = String(pin || '').replace(/\D/g, '').slice(0, 6);
      if (!/^\d{6}$/.test(next)) return;
      trackExpress('pin_saved', { surface: surface || 'header' });
    },
    tagged: function (variantId) {
      var id = String(variantId || '').trim();
      if (!id) return;
      var key = 'WfwExpressTagged:' + id;
      try {
        if (sessionStorage.getItem(key) === '1') return;
        sessionStorage.setItem(key, '1');
      } catch (e) {}
      trackExpress('variant_tagged', { express_variant_id: id });
    }
  };
  var FALLBACK_PATH = '/collections/new';
  var API_BASE = window.WfwDeliveryStatusUrl;
  /* LIVE status host is snippets/delivery-status-url.liquid
  var API_BASE = 'https://impulse-backend.heliumbuilder.com/api/delivery/status';
  */
  var SHOP_DOMAIN = 'shopforw.myshopify.com';
  var NO_EXPRESS_MESSAGE = 'No express delivery products available at your location.';
  function isValidPin(pin) {
    return /^\d{6}$/.test(String(pin || '').trim());
  }

  function readPin() {
    var api = window.WFWDeliverySlaApi;
    if (api && typeof api.getPincode === 'function') {
      var fromApi = api.getPincode();
      if (isValidPin(fromApi)) return String(fromApi).trim();
    }
    try {
      var stored = localStorage.getItem(PIN_KEY);
      if (isValidPin(stored)) return String(stored).trim();
    } catch (e) {}
    return '';
  }

  function readCache(pin) {
    try {
      var value = sessionStorage.getItem(CACHE_PREFIX + pin);
      if (value === '1') return true;
      if (value === '0') return false;
    } catch (e) {}
    return null;
  }

  function setToggle(on) {
    try {
      localStorage.setItem(TOGGLE_KEY, on ? '1' : '0');
    } catch (e) {}
    document.querySelectorAll('[data-w-express-toggle]').forEach(function (button) {
      button.classList.toggle('is-on', on);
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.dispatchEvent(new CustomEvent('wfw:express-toggle', { detail: { on: on } }));
  }

  function writeCache(pin, eligible) {
    try {
      sessionStorage.setItem(CACHE_PREFIX + pin, eligible ? '1' : '0');
    } catch (e) {}
  }

  function isExpress(row) {
    if (!row) return false;
    var type = String(row.deliveryType || '');
    if (type === 'SDD' || type === 'NDD') return true;
    var hours = Number(row.totalHours);
    return isFinite(hours) && hours <= 48;
  }

  function productSkus(products, max) {
    var skus = [];
    (products || []).forEach(function (product) {
      if (skus.length >= max) return;
      var variants = product.variants || [];
      for (var i = 0; i < variants.length; i++) {
        var sku = String((variants[i] && variants[i].sku) || '').trim();
        if (!sku) continue;
        skus.push(sku);
        break;
      }
    });
    return skus;
  }

  var expressProductsPromise = null;
  var newProductsPromise = null;

  function loadProducts(path, limit, slot) {
    if (slot.current) return slot.current;
    slot.current = fetch(path + '/products.json?limit=' + limit, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        if (!res.ok) throw new Error('products');
        return res.json();
      })
      .then(function (data) {
        return data.products || [];
      })
      .catch(function (err) {
        slot.current = null;
        throw err;
      });
    return slot.current;
  }

  function loadExpressProducts() {
    if (!expressProductsPromise) expressProductsPromise = { current: null };
    return loadProducts(EXPRESS_PATH, 12, expressProductsPromise);
  }

  function loadNewProducts() {
    if (!newProductsPromise) newProductsPromise = { current: null };
    return loadProducts(FALLBACK_PATH, 50, newProductsPromise);
  }

  function statusHasExpress(skus, pin) {
    if (!skus.length) return Promise.resolve(false);
    var url = new URL(API_BASE);
    url.searchParams.set('skus', skus.join(','));
    url.searchParams.set('deliveryPostcode', pin);
    url.searchParams.set('shop', SHOP_DOMAIN);
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = setTimeout(function () {
      if (controller) controller.abort();
    }, 5000);
    return fetch(url.toString(), controller ? { signal: controller.signal } : undefined)
      .then(function (res) {
        clearTimeout(timer);
        if (!res.ok) throw new Error('status');
        return res.json();
      })
      .then(function (json) {
        var rows = json && json.successful && Array.isArray(json.results) ? json.results : [];
        return rows.some(isExpress);
      })
      .catch(function (err) {
        clearTimeout(timer);
        throw err;
      });
  }

  function probeSkus(skus, pin) {
    var chain = Promise.resolve(false);
    for (var i = 0; i < skus.length; i += 60) {
      (function (chunk) {
        chain = chain.then(function (found) {
          if (found) return true;
          return statusHasExpress(chunk, pin);
        });
      })(skus.slice(i, i + 60));
    }
    return chain;
  }

  function pageHasExpressCard() {
    return !!document.querySelector('[data-w-express-row].is-visible');
  }

  function pageSkus() {
    var skus = [];
    var seen = {};
    document.querySelectorAll('.card-wrapper[data-delivery-skus]').forEach(function (card) {
      String(card.getAttribute('data-delivery-skus') || '').split(',').forEach(function (sku) {
        sku = String(sku || '').trim();
        if (!sku || seen[sku]) return;
        seen[sku] = 1;
        skus.push(sku);
      });
    });
    return skus.slice(0, 30);
  }

  function checkEligible(pin) {
    if (pageHasExpressCard()) {
      writeCache(pin, true);
      return Promise.resolve(true);
    }
    var cached = readCache(pin);
    if (cached === true) return Promise.resolve(true);
    var expressProbe = loadExpressProducts().then(function (products) {
      return probeSkus(productSkus(products, 12), pin);
    });
    var newProbe = loadNewProducts().then(function (products) {
      return probeSkus(productSkus(products, 50), pin);
    });
    var pageProbe = probeSkus(pageSkus(), pin);
    return new Promise(function (resolve, reject) {
      var pending = 3;
      var doneOk = 0;
      var settled = false;
      function finish(eligible) {
        if (settled) return;
        settled = true;
        writeCache(pin, eligible);
        resolve(eligible);
      }
      function one(probe) {
        probe
          .then(function (hit) {
            doneOk += 1;
            if (hit) finish(true);
          })
          .catch(function () {})
          .then(function () {
            pending -= 1;
            if (settled || pending > 0) return;
            if (pageHasExpressCard()) finish(true);
            else if (doneOk === 3) finish(false);
            else reject(new Error('status'));
          });
      }
      one(expressProbe);
      one(newProbe);
      one(pageProbe);
    });
  }

  function showNoExpressSnackbar() {
    var existing = document.getElementById('wfw-express-snackbar');
    if (existing) existing.parentNode.removeChild(existing);
    var bar = document.createElement('div');
    bar.id = 'wfw-express-snackbar';
    bar.setAttribute('role', 'status');
    bar.textContent = NO_EXPRESS_MESSAGE;
    bar.style.cssText =
      'position:fixed;left:16px;right:16px;bottom:96px;z-index:90;margin:0 auto;max-width:420px;padding:12px 14px;background:#111;color:#fff;border-radius:8px;font-size:14px;line-height:1.4;text-align:center;box-shadow:0 8px 24px rgba(0,0,0,.25)';
    document.body.appendChild(bar);
  }

  function goExpress() {
    if (window.location.pathname.indexOf(EXPRESS_PATH) === 0) return;
    window.location.assign(EXPRESS_PATH);
  }

  function goNoExpress() {
    setToggle(false);
    showNoExpressSnackbar();
    setTimeout(function () {
      window.location.assign(FALLBACK_PATH);
    }, 1800);
  }

  function ensureModal() {
    var existing = document.getElementById('wfw-express-pin-modal');
    if (existing) return existing;
    var style = document.createElement('style');
    style.textContent =
      '#wfw-express-pin-modal{position:fixed;left:0;right:0;bottom:0;top:0;z-index:1200;display:flex;align-items:flex-start;justify-content:center;background:rgba(0,0,0,.45)}' +
      '#wfw-express-pin-modal[hidden]{display:none}' +
      '.wfw-express-pin-modal__card{position:relative;width:100%;max-width:420px;margin:0;padding:10px 12px 12px;background:#bf1616;border-radius:0 0 10px 10px;box-sizing:border-box}' +
      '.wfw-express-pin-modal__title{margin:0 22px 8px 0;font-size:13px;line-height:1.25;font-weight:600;color:#fff}' +
      '.wfw-express-pin-modal__close{position:absolute;top:4px;right:4px;width:24px;height:24px;border:0;background:none;color:#fff;font-size:18px;line-height:1;cursor:pointer}' +
      '.wfw-express-pin-modal__row{display:block}' +
      '.wfw-express-pin-modal__input{width:100%;height:34px;padding:0 8px;border:1px solid #d4d5d9;border-radius:4px;font-size:16px;color:#111;box-sizing:border-box}' +
      '.wfw-express-pin-modal__input:focus{outline:none;border-color:#b7b7b7}' +
      '@media(min-width:750px){#wfw-express-pin-modal{align-items:center}.wfw-express-pin-modal__card{border-radius:12px}}';
    document.head.appendChild(style);
    var root = document.createElement('div');
    root.id = 'wfw-express-pin-modal';
    root.hidden = true;
    root.innerHTML =
      '<div class="wfw-express-pin-modal__card" role="dialog" aria-modal="true" aria-labelledby="wfw-express-pin-title">' +
      '<button type="button" class="wfw-express-pin-modal__close" data-w-express-pin-close aria-label="Close">&times;</button>' +
      '<p id="wfw-express-pin-title" class="wfw-express-pin-modal__title">Enter your pincode for express delivery</p>' +
      '<form class="wfw-express-pin-modal__row" data-w-express-pin-form>' +
      '<input class="wfw-express-pin-modal__input" data-w-express-pin-input inputmode="numeric" maxlength="6" autocomplete="postal-code" aria-label="Delivery pincode" placeholder="Pincode">' +
      '</form></div>';
    document.body.appendChild(root);
    root.addEventListener('click', function (event) {
      if (event.target === root || event.target.closest('[data-w-express-pin-close]')) closeModal();
    });
    function acceptPin(raw) {
      var pin = String(raw || '').replace(/\D/g, '').slice(0, 6);
      if (!isValidPin(pin) || root.getAttribute('data-pin-accepted') === '1') return;
      root.setAttribute('data-pin-accepted', '1');
      var surface = root.getAttribute('data-pin-surface') || 'header';
      window.WfwExpressTrack.pin(pin, surface);
      commitPin(pin);
      if (surface === 'bottom_nav' || surface === 'menu') goExpress();
    }
    var input = root.querySelector('[data-w-express-pin-input]');
    function readTypedPin() {
      var pin = String(input.value || '').replace(/\D/g, '').slice(0, 6);
      if (input.value !== pin) input.value = pin;
      if (pin.length === 6 && pin !== root.getAttribute('data-pin-hold')) acceptPin(pin);
    }
    root.querySelector('[data-w-express-pin-form]').addEventListener('submit', function (event) {
      event.preventDefault();
      readTypedPin();
    });
    input.addEventListener('keyup', readTypedPin);
    input.addEventListener('input', readTypedPin);
    input.addEventListener('change', readTypedPin);
    input.addEventListener('paste', function () {
      setTimeout(readTypedPin, 0);
    });
    root._wfwReadPin = readTypedPin;
    return root;
  }

  function headerBottom() {
    var header = document.querySelector('.custom_header') || document.querySelector('.shopify-section-header');
    if (!header) return 0;
    return Math.max(0, Math.round(header.getBoundingClientRect().bottom));
  }

  function placeModal(root) {
    var mobile = window.innerWidth < 750;
    root.style.top = mobile ? headerBottom() + 'px' : '0px';
  }

  function openModal(surface) {
    loadExpressProducts();
    loadNewProducts();
    var root = ensureModal();
    placeModal(root);
    root.removeAttribute('data-pin-accepted');
    root.setAttribute('data-pin-surface', surface || 'header');
    root.style.display = '';
    root.hidden = false;
    var input = root.querySelector('[data-w-express-pin-input]');
    var existing = '';
    try {
      existing = localStorage.getItem('ExistPincode') || '';
    } catch (e) {}
    if (!/^\d{6}$/.test(existing)) existing = '';
    root.setAttribute('data-pin-hold', existing);
    input.value = existing;
    input.focus();
    if (existing) input.select();
    var timer = setInterval(function () {
      if (root.hidden || root.getAttribute('data-pin-accepted') === '1') {
        clearInterval(timer);
        return;
      }
      if (typeof root._wfwReadPin === 'function') root._wfwReadPin();
    }, 100);
  }

  function closeModal() {
    var root = document.getElementById('wfw-express-pin-modal');
    if (!root) return;
    root.hidden = true;
    root.style.display = 'none';
  }

  function commitPin(raw) {
    var pin = String(raw || '').replace(/\D/g, '').slice(0, 6);
    if (!isValidPin(pin)) return;
    try {
      localStorage.setItem(PIN_KEY, pin);
      sessionStorage.setItem('WfwSessionPincode', pin);
    } catch (e) {}
    var api = window.WFWDeliverySlaApi;
    if (api && typeof api.setPincode === 'function') {
      try { api.setPincode(pin); } catch (e) {}
    } else {
      try {
        document.dispatchEvent(new CustomEvent('wfw:pincode-updated', { detail: { pincode: pin } }));
      } catch (e2) {}
    }
    closeModal();
  }

  var routing = false;

  function route(pin) {
    if (routing) return;
    routing = true;
    if (pageHasExpressCard() || readCache(pin) === true) {
      writeCache(pin, true);
      routing = false;
      goExpress();
      return;
    }
    checkEligible(pin)
      .then(function (eligible) {
        routing = false;
        if (eligible || pageHasExpressCard()) {
          writeCache(pin, true);
          goExpress();
        } else goNoExpress();
      })
      .catch(function () {
        routing = false;
        goExpress();
      });
  }

  function onExpressClick(event) {
    var trigger = event.target.closest('[data-w-express-nav]');
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    var surface = trigger.classList.contains('w-express-menu') ? 'menu' : 'bottom_nav';
    trackExpress('express_click', { surface: surface });
    var pin = readPin();
    if (!pin) {
      openModal(surface);
      return;
    }
    route(pin);
  }

  function syncToggleFromPin() {
    try {
      if (localStorage.getItem('WfwExpressToggleReset') !== '1') {
        localStorage.setItem(TOGGLE_KEY, '0');
        localStorage.setItem('WfwExpressToggleReset', '1');
      }
    } catch (e) {}
    if (!readPin()) {
      setToggle(false);
      return;
    }
    var saved = null;
    try {
      saved = localStorage.getItem(TOGGLE_KEY);
    } catch (e2) {}
    setToggle(saved === '1');
  }

  function showVisitHint() {
    if (window.matchMedia('(min-width: 768px)').matches) return;
    var seen = false;
    try {
      seen = sessionStorage.getItem('WfwExpressVisitHint') === '1';
    } catch (e) {}
    if (seen || document.getElementById('wfw-express-visit')) return;
    try {
      sessionStorage.setItem('WfwExpressVisitHint', '1');
    } catch (e2) {}
    if (!document.getElementById('wfw-express-visit-style')) {
      var style = document.createElement('style');
      style.id = 'wfw-express-visit-style';
      style.textContent =
        '#wfw-express-visit{position:fixed;left:16px;right:16px;bottom:24px;z-index:30;display:flex;align-items:center;justify-content:center;flex-wrap:wrap;gap:6px;margin:0 auto;max-width:420px;padding:10px 8px 10px 12px;background:#111;color:#fff;border-radius:8px;font-size:13px;line-height:1.3;box-shadow:0 8px 24px rgba(0,0,0,.25)}' +
        '#wfw-express-visit img{display:block;width:auto;height:18px;flex:0 0 auto}' +
        '#wfw-express-visit button{appearance:none;margin:0 0 0 4px;padding:0 4px;border:0;background:none;color:#fff;font-size:18px;line-height:1;cursor:pointer}' +
        '#wfw-express-visit .wfw-express-visit__tail{position:absolute;width:0;height:0;margin:0;padding:0;border-style:solid;border-width:8px 7px 0;border-color:#111 transparent transparent;pointer-events:none}' +
        '@media(max-width:767px){#wfw-express-visit img{display:none}}' +
        '@media(min-width:768px){#wfw-express-visit{display:none}}';
      document.head.appendChild(style);
    }
    var mark = document.querySelector('.w-express-toggle__mark');
    var src = mark ? mark.getAttribute('src') : '';
    var chip = document.createElement('div');
    chip.id = 'wfw-express-visit';
    chip.setAttribute('role', 'status');
    // WFW NEXT DAY DELIVERY HINT START
    // ORIGINAL START — rollback: remove the new assignment below and uncomment this assignment.
    // chip.innerHTML =
    //   '<span>Visit to discover W Express</span>' +
    //   (src ? '<img alt="" width="42" height="18" src="' + src.replace(/"/g, '&quot;') + '">' : '') +
    //   '<span>products</span>' +
    //   '<button type="button" aria-label="Close">&times;</button>' +
    //   '<span class="wfw-express-visit__tail" aria-hidden="true"></span>';
    // ORIGINAL END
    chip.innerHTML =
      '<span>Explore Next Day Delivery</span>' +
      '<button type="button" aria-label="Close">&times;</button>' +
      '<span class="wfw-express-visit__tail" aria-hidden="true"></span>';
    // WFW NEXT DAY DELIVERY HINT END
    document.body.appendChild(chip);
    function placeVisitHint() {
      var btn = document.querySelector('.bottom-nav-wrapper [data-w-express-nav]');
      var tail = chip.querySelector('.wfw-express-visit__tail');
      if (!btn || !tail) return;
      var rect = btn.getBoundingClientRect();
      if (window.matchMedia('(min-width: 768px)').matches || rect.width < 1 || rect.height < 1) {
        chip.style.display = 'none';
        return;
      }
      chip.style.display = '';
      chip.style.right = 'auto';
      chip.style.width = 'max-content';
      chip.style.maxWidth = 'calc(100vw - 24px)';
      var width = chip.offsetWidth;
      var center = rect.left + rect.width / 2;
      var margin = 12;
      var left = Math.round(center - width / 2);
      var maxLeft = window.innerWidth - margin - width;
      if (left < margin) left = margin;
      if (left > maxLeft) left = Math.max(margin, maxLeft);
      chip.style.left = left + 'px';
      chip.style.bottom = Math.round(window.innerHeight - rect.top + 10) + 'px';
      var tip = Math.round(center - left - 7);
      if (tip < 12) tip = 12;
      if (tip > width - 26) tip = width - 26;
      tail.style.display = 'block';
      tail.style.left = tip + 'px';
      tail.style.bottom = '-8px';
    }
    placeVisitHint();
    window.addEventListener('resize', placeVisitHint);
    function close() {
      if (chip.parentNode) chip.parentNode.removeChild(chip);
    }
    var timer = window.setTimeout(close, 5000);
    chip.querySelector('button').addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      window.clearTimeout(timer);
      close();
    });
  }

  function init() {
    document.addEventListener('click', onExpressClick);
    document.addEventListener('wfw:express-pin-needed', function () {
      openModal('header');
    });
    document.addEventListener('wfw:express-pin-submit', function (event) {
      var pin = event && event.detail ? event.detail.pincode : '';
      window.WfwExpressTrack.pin(pin, 'header');
      commitPin(pin);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeModal();
    });
    trackExpress('user');
    syncToggleFromPin();
    showVisitHint();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/* WFW EXPRESS NAV END */

// /* WFW EXPRESS NAV START */
// (function () {
//   'use strict';

//   if (document.documentElement.classList.contains('h-ab-live')) return;

//   var PIN_KEY = 'ExistPincode';
//   var TOGGLE_KEY = 'WfwExpressOn';
//   var CACHE_PREFIX = 'WfwExpressEligible:v2:';
//   var EXPRESS_PATH = '/collections/w-express-delivery';

//   var EXPRESS_BUTTONS = {
//     header: 'Header Pincode Fill',
//     toggle: 'Header Filter Toggle',
//     bottom_nav: 'Bottom Nav. Landing Page',
//     menu: 'Menu Slide Landing Page',
//     collection_pin: 'CLP Pincode Box',
//     product_pin: 'PDP Pincode Box'
//   };

//   function whenExpressTrackReady(done) {
//     function ready() {
//       return !!(
//         window.HeliumUtils &&
//         window.HeliumUtils.tracking &&
//         window.HeliumUtils.tracking.feature &&
//         typeof window.HeliumUtils.tracking.feature.triggered === 'function'
//       );
//     }
//     if (ready()) {
//       done();
//       return;
//     }
//     var tries = 0;
//     var timer = setInterval(function () {
//       tries += 1;
//       if (ready() || tries > 40) {
//         clearInterval(timer);
//         done();
//       }
//     }, 250);
//   }

//   function trackExpress(step, extra) {
//     var surface = extra && extra.surface;
//     var saved = !!storedPin();
//     var strategy = '';
//     var tags = null;
//     if (step === 'variant_tagged') {
//       tags = { name: 'w_express', id: 'variant_tagged' };
//     } else {
//       if (step === 'user') strategy = saved ? 'saved-user' : 'unsaved-user';
//       else strategy = EXPRESS_BUTTONS[surface] || '';
//       if (!strategy) return;
//       tags = {
//         name: 'w_express',
//         id: strategy,
//         strategyId: strategy,
//         variant: saved ? 'saved' : 'unsaved'
//       };
//     }
//     var payload = { did_render: true };
//     if (extra) {
//       Object.keys(extra).forEach(function (key) {
//         if (key === 'pinState' || key === 'surface') return;
//         payload[key] = extra[key];
//       });
//     }
//     whenExpressTrackReady(function () {
//       try {
//         var feature = window.HeliumUtils.tracking.feature;
//         if (!feature || typeof feature.triggered !== 'function') return;
//         feature.triggered(tags, payload);
//       } catch (e) {}
//     });
//   }

//   function storedPin() {
//     try {
//       var pin = localStorage.getItem(PIN_KEY) || '';
//       return /^\d{6}$/.test(pin) ? pin : '';
//     } catch (e) {
//       return '';
//     }
//   }

//   window.WfwExpressTrack = {
//     event: trackExpress,
//     pin: function (pin, surface) {
//       var next = String(pin || '').replace(/\D/g, '').slice(0, 6);
//       if (!/^\d{6}$/.test(next)) return;
//       trackExpress('pin_saved', { surface: surface || 'header' });
//     },
//     tagged: function (variantId) {
//       var id = String(variantId || '').trim();
//       if (!id) return;
//       var key = 'WfwExpressTagged:' + id;
//       try {
//         if (sessionStorage.getItem(key) === '1') return;
//         sessionStorage.setItem(key, '1');
//       } catch (e) {}
//       trackExpress('variant_tagged', { express_variant_id: id });
//     }
//   };
//   var FALLBACK_PATH = '/collections/new';
//   var API_BASE = window.WfwDeliveryStatusUrl;
//   /* LIVE status host is snippets/delivery-status-url.liquid
//   var API_BASE = 'https://impulse-backend.heliumbuilder.com/api/delivery/status';
//   */
//   var SHOP_DOMAIN = 'shopforw.myshopify.com';
//   var NO_EXPRESS_MESSAGE = 'No express delivery products available at your location.';
//   function isValidPin(pin) {
//     return /^\d{6}$/.test(String(pin || '').trim());
//   }

//   function readPin() {
//     var api = window.WFWDeliverySlaApi;
//     if (api && typeof api.getPincode === 'function') {
//       var fromApi = api.getPincode();
//       if (isValidPin(fromApi)) return String(fromApi).trim();
//     }
//     try {
//       var stored = localStorage.getItem(PIN_KEY);
//       if (isValidPin(stored)) return String(stored).trim();
//     } catch (e) {}
//     return '';
//   }

//   function readCache(pin) {
//     try {
//       var value = sessionStorage.getItem(CACHE_PREFIX + pin);
//       if (value === '1') return true;
//       if (value === '0') return false;
//     } catch (e) {}
//     return null;
//   }

//   function setToggle(on) {
//     try {
//       localStorage.setItem(TOGGLE_KEY, on ? '1' : '0');
//     } catch (e) {}
//     document.querySelectorAll('[data-w-express-toggle]').forEach(function (button) {
//       button.classList.toggle('is-on', on);
//       button.setAttribute('aria-pressed', on ? 'true' : 'false');
//     });
//     document.dispatchEvent(new CustomEvent('wfw:express-toggle', { detail: { on: on } }));
//   }

//   function writeCache(pin, eligible) {
//     try {
//       sessionStorage.setItem(CACHE_PREFIX + pin, eligible ? '1' : '0');
//     } catch (e) {}
//   }

//   function isExpress(row) {
//     if (!row) return false;
//     var type = String(row.deliveryType || '');
//     if (type === 'SDD' || type === 'NDD') return true;
//     var hours = Number(row.totalHours);
//     return isFinite(hours) && hours <= 48;
//   }

//   function productSkus(products, max) {
//     var skus = [];
//     (products || []).forEach(function (product) {
//       if (skus.length >= max) return;
//       var variants = product.variants || [];
//       for (var i = 0; i < variants.length; i++) {
//         var sku = String((variants[i] && variants[i].sku) || '').trim();
//         if (!sku) continue;
//         skus.push(sku);
//         break;
//       }
//     });
//     return skus;
//   }

//   var expressProductsPromise = null;
//   var newProductsPromise = null;

//   function loadProducts(path, limit, slot) {
//     if (slot.current) return slot.current;
//     slot.current = fetch(path + '/products.json?limit=' + limit, {
//       credentials: 'same-origin',
//       headers: { Accept: 'application/json' },
//     })
//       .then(function (res) {
//         if (!res.ok) throw new Error('products');
//         return res.json();
//       })
//       .then(function (data) {
//         return data.products || [];
//       })
//       .catch(function (err) {
//         slot.current = null;
//         throw err;
//       });
//     return slot.current;
//   }

//   function loadExpressProducts() {
//     if (!expressProductsPromise) expressProductsPromise = { current: null };
//     return loadProducts(EXPRESS_PATH, 12, expressProductsPromise);
//   }

//   function loadNewProducts() {
//     if (!newProductsPromise) newProductsPromise = { current: null };
//     return loadProducts(FALLBACK_PATH, 50, newProductsPromise);
//   }

//   function statusHasExpress(skus, pin) {
//     if (!skus.length) return Promise.resolve(false);
//     var url = new URL(API_BASE);
//     url.searchParams.set('skus', skus.join(','));
//     url.searchParams.set('deliveryPostcode', pin);
//     url.searchParams.set('shop', SHOP_DOMAIN);
//     var controller = typeof AbortController === 'function' ? new AbortController() : null;
//     var timer = setTimeout(function () {
//       if (controller) controller.abort();
//     }, 5000);
//     return fetch(url.toString(), controller ? { signal: controller.signal } : undefined)
//       .then(function (res) {
//         clearTimeout(timer);
//         if (!res.ok) throw new Error('status');
//         return res.json();
//       })
//       .then(function (json) {
//         var rows = json && json.successful && Array.isArray(json.results) ? json.results : [];
//         return rows.some(isExpress);
//       })
//       .catch(function (err) {
//         clearTimeout(timer);
//         throw err;
//       });
//   }

//   function probeSkus(skus, pin) {
//     var chain = Promise.resolve(false);
//     for (var i = 0; i < skus.length; i += 60) {
//       (function (chunk) {
//         chain = chain.then(function (found) {
//           if (found) return true;
//           return statusHasExpress(chunk, pin);
//         });
//       })(skus.slice(i, i + 60));
//     }
//     return chain;
//   }

//   function pageHasExpressCard() {
//     return !!document.querySelector('[data-w-express-row].is-visible');
//   }

//   function pageSkus() {
//     var skus = [];
//     var seen = {};
//     document.querySelectorAll('.card-wrapper[data-delivery-skus]').forEach(function (card) {
//       String(card.getAttribute('data-delivery-skus') || '').split(',').forEach(function (sku) {
//         sku = String(sku || '').trim();
//         if (!sku || seen[sku]) return;
//         seen[sku] = 1;
//         skus.push(sku);
//       });
//     });
//     return skus.slice(0, 30);
//   }

//   function checkEligible(pin) {
//     if (pageHasExpressCard()) {
//       writeCache(pin, true);
//       return Promise.resolve(true);
//     }
//     var cached = readCache(pin);
//     if (cached === true) return Promise.resolve(true);
//     var expressProbe = loadExpressProducts().then(function (products) {
//       return probeSkus(productSkus(products, 12), pin);
//     });
//     var newProbe = loadNewProducts().then(function (products) {
//       return probeSkus(productSkus(products, 50), pin);
//     });
//     var pageProbe = probeSkus(pageSkus(), pin);
//     return new Promise(function (resolve, reject) {
//       var pending = 3;
//       var doneOk = 0;
//       var settled = false;
//       function finish(eligible) {
//         if (settled) return;
//         settled = true;
//         writeCache(pin, eligible);
//         resolve(eligible);
//       }
//       function one(probe) {
//         probe
//           .then(function (hit) {
//             doneOk += 1;
//             if (hit) finish(true);
//           })
//           .catch(function () {})
//           .then(function () {
//             pending -= 1;
//             if (settled || pending > 0) return;
//             if (pageHasExpressCard()) finish(true);
//             else if (doneOk === 3) finish(false);
//             else reject(new Error('status'));
//           });
//       }
//       one(expressProbe);
//       one(newProbe);
//       one(pageProbe);
//     });
//   }

//   function showNoExpressSnackbar() {
//     var existing = document.getElementById('wfw-express-snackbar');
//     if (existing) existing.parentNode.removeChild(existing);
//     var bar = document.createElement('div');
//     bar.id = 'wfw-express-snackbar';
//     bar.setAttribute('role', 'status');
//     bar.textContent = NO_EXPRESS_MESSAGE;
//     bar.style.cssText =
//       'position:fixed;left:16px;right:16px;bottom:96px;z-index:90;margin:0 auto;max-width:420px;padding:12px 14px;background:#111;color:#fff;border-radius:8px;font-size:14px;line-height:1.4;text-align:center;box-shadow:0 8px 24px rgba(0,0,0,.25)';
//     document.body.appendChild(bar);
//   }

//   function goExpress() {
//     if (window.location.pathname.indexOf(EXPRESS_PATH) === 0) return;
//     window.location.assign(EXPRESS_PATH);
//   }

//   function goNoExpress() {
//     setToggle(false);
//     showNoExpressSnackbar();
//     setTimeout(function () {
//       window.location.assign(FALLBACK_PATH);
//     }, 1800);
//   }

//   function ensureModal() {
//     var existing = document.getElementById('wfw-express-pin-modal');
//     if (existing) return existing;
//     var style = document.createElement('style');
//     style.textContent =
//       '#wfw-express-pin-modal{position:fixed;left:0;right:0;bottom:0;top:0;z-index:1200;display:flex;align-items:flex-start;justify-content:center;background:rgba(0,0,0,.45)}' +
//       '#wfw-express-pin-modal[hidden]{display:none}' +
//       '.wfw-express-pin-modal__card{position:relative;width:100%;max-width:420px;margin:0;padding:10px 12px 12px;background:#bf1616;border-radius:0 0 10px 10px;box-sizing:border-box}' +
//       '.wfw-express-pin-modal__title{margin:0 22px 8px 0;font-size:13px;line-height:1.25;font-weight:600;color:#fff}' +
//       '.wfw-express-pin-modal__close{position:absolute;top:4px;right:4px;width:24px;height:24px;border:0;background:none;color:#fff;font-size:18px;line-height:1;cursor:pointer}' +
//       '.wfw-express-pin-modal__row{display:block}' +
//       '.wfw-express-pin-modal__input{width:100%;height:34px;padding:0 8px;border:1px solid #d4d5d9;border-radius:4px;font-size:16px;color:#111;box-sizing:border-box}' +
//       '.wfw-express-pin-modal__input:focus{outline:none;border-color:#b7b7b7}' +
//       '@media(min-width:750px){#wfw-express-pin-modal{align-items:center}.wfw-express-pin-modal__card{border-radius:12px}}';
//     document.head.appendChild(style);
//     var root = document.createElement('div');
//     root.id = 'wfw-express-pin-modal';
//     root.hidden = true;
//     root.innerHTML =
//       '<div class="wfw-express-pin-modal__card" role="dialog" aria-modal="true" aria-labelledby="wfw-express-pin-title">' +
//       '<button type="button" class="wfw-express-pin-modal__close" data-w-express-pin-close aria-label="Close">&times;</button>' +
//       '<p id="wfw-express-pin-title" class="wfw-express-pin-modal__title">Enter your pincode for express delivery</p>' +
//       '<form class="wfw-express-pin-modal__row" data-w-express-pin-form>' +
//       '<input class="wfw-express-pin-modal__input" data-w-express-pin-input inputmode="numeric" maxlength="6" autocomplete="postal-code" aria-label="Delivery pincode" placeholder="Pincode">' +
//       '</form></div>';
//     document.body.appendChild(root);
//     root.addEventListener('click', function (event) {
//       if (event.target === root || event.target.closest('[data-w-express-pin-close]')) closeModal();
//     });
//     function acceptPin(raw) {
//       var pin = String(raw || '').replace(/\D/g, '').slice(0, 6);
//       if (!isValidPin(pin) || root.getAttribute('data-pin-accepted') === '1') return;
//       root.setAttribute('data-pin-accepted', '1');
//       var surface = root.getAttribute('data-pin-surface') || 'header';
//       window.WfwExpressTrack.pin(pin, surface);
//       commitPin(pin);
//       if (surface === 'bottom_nav' || surface === 'menu') goExpress();
//     }
//     var input = root.querySelector('[data-w-express-pin-input]');
//     function readTypedPin() {
//       var pin = String(input.value || '').replace(/\D/g, '').slice(0, 6);
//       if (input.value !== pin) input.value = pin;
//       if (pin.length === 6 && pin !== root.getAttribute('data-pin-hold')) acceptPin(pin);
//     }
//     root.querySelector('[data-w-express-pin-form]').addEventListener('submit', function (event) {
//       event.preventDefault();
//       readTypedPin();
//     });
//     input.addEventListener('keyup', readTypedPin);
//     input.addEventListener('input', readTypedPin);
//     input.addEventListener('change', readTypedPin);
//     input.addEventListener('paste', function () {
//       setTimeout(readTypedPin, 0);
//     });
//     root._wfwReadPin = readTypedPin;
//     return root;
//   }

//   function headerBottom() {
//     var header = document.querySelector('.custom_header') || document.querySelector('.shopify-section-header');
//     if (!header) return 0;
//     return Math.max(0, Math.round(header.getBoundingClientRect().bottom));
//   }

//   function placeModal(root) {
//     var mobile = window.innerWidth < 750;
//     root.style.top = mobile ? headerBottom() + 'px' : '0px';
//   }

//   function openModal(surface) {
//     loadExpressProducts();
//     loadNewProducts();
//     var root = ensureModal();
//     placeModal(root);
//     root.removeAttribute('data-pin-accepted');
//     root.setAttribute('data-pin-surface', surface || 'header');
//     root.style.display = '';
//     root.hidden = false;
//     var input = root.querySelector('[data-w-express-pin-input]');
//     var existing = '';
//     try {
//       existing = localStorage.getItem('ExistPincode') || '';
//     } catch (e) {}
//     if (!/^\d{6}$/.test(existing)) existing = '';
//     root.setAttribute('data-pin-hold', existing);
//     input.value = existing;
//     input.focus();
//     if (existing) input.select();
//     var timer = setInterval(function () {
//       if (root.hidden || root.getAttribute('data-pin-accepted') === '1') {
//         clearInterval(timer);
//         return;
//       }
//       if (typeof root._wfwReadPin === 'function') root._wfwReadPin();
//     }, 100);
//   }

//   function closeModal() {
//     var root = document.getElementById('wfw-express-pin-modal');
//     if (!root) return;
//     root.hidden = true;
//     root.style.display = 'none';
//   }

//   function commitPin(raw) {
//     var pin = String(raw || '').replace(/\D/g, '').slice(0, 6);
//     if (!isValidPin(pin)) return;
//     try {
//       localStorage.setItem(PIN_KEY, pin);
//       sessionStorage.setItem('WfwSessionPincode', pin);
//     } catch (e) {}
//     var api = window.WFWDeliverySlaApi;
//     if (api && typeof api.setPincode === 'function') {
//       try { api.setPincode(pin); } catch (e) {}
//     } else {
//       try {
//         document.dispatchEvent(new CustomEvent('wfw:pincode-updated', { detail: { pincode: pin } }));
//       } catch (e2) {}
//     }
//     closeModal();
//   }

//   var routing = false;

//   function route(pin) {
//     if (routing) return;
//     routing = true;
//     if (pageHasExpressCard() || readCache(pin) === true) {
//       writeCache(pin, true);
//       routing = false;
//       goExpress();
//       return;
//     }
//     checkEligible(pin)
//       .then(function (eligible) {
//         routing = false;
//         if (eligible || pageHasExpressCard()) {
//           writeCache(pin, true);
//           goExpress();
//         } else goNoExpress();
//       })
//       .catch(function () {
//         routing = false;
//         goExpress();
//       });
//   }

//   function onExpressClick(event) {
//     var trigger = event.target.closest('[data-w-express-nav]');
//     if (!trigger) return;
//     event.preventDefault();
//     event.stopPropagation();
//     var surface = trigger.classList.contains('w-express-menu') ? 'menu' : 'bottom_nav';
//     trackExpress('express_click', { surface: surface });
//     var pin = readPin();
//     if (!pin) {
//       openModal(surface);
//       return;
//     }
//     route(pin);
//   }

//   function syncToggleFromPin() {
//     try {
//       if (localStorage.getItem('WfwExpressToggleReset') !== '1') {
//         localStorage.setItem(TOGGLE_KEY, '0');
//         localStorage.setItem('WfwExpressToggleReset', '1');
//       }
//     } catch (e) {}
//     if (!readPin()) {
//       setToggle(false);
//       return;
//     }
//     var saved = null;
//     try {
//       saved = localStorage.getItem(TOGGLE_KEY);
//     } catch (e2) {}
//     setToggle(saved === '1');
//   }

//   function showVisitHint() {
//     if (window.matchMedia('(min-width: 768px)').matches) return;
//     var seen = false;
//     try {
//       seen = sessionStorage.getItem('WfwExpressVisitHint') === '1';
//     } catch (e) {}
//     if (seen || document.getElementById('wfw-express-visit')) return;
//     try {
//       sessionStorage.setItem('WfwExpressVisitHint', '1');
//     } catch (e2) {}
//     if (!document.getElementById('wfw-express-visit-style')) {
//       var style = document.createElement('style');
//       style.id = 'wfw-express-visit-style';
//       style.textContent =
//         '#wfw-express-visit{position:fixed;left:16px;right:16px;bottom:24px;z-index:30;display:flex;align-items:center;justify-content:center;flex-wrap:wrap;gap:6px;margin:0 auto;max-width:420px;padding:10px 8px 10px 12px;background:#111;color:#fff;border-radius:8px;font-size:13px;line-height:1.3;box-shadow:0 8px 24px rgba(0,0,0,.25)}' +
//         '#wfw-express-visit img{display:block;width:auto;height:18px;flex:0 0 auto}' +
//         '#wfw-express-visit button{appearance:none;margin:0 0 0 4px;padding:0 4px;border:0;background:none;color:#fff;font-size:18px;line-height:1;cursor:pointer}' +
//         '#wfw-express-visit .wfw-express-visit__tail{position:absolute;width:0;height:0;margin:0;padding:0;border-style:solid;border-width:8px 7px 0;border-color:#111 transparent transparent;pointer-events:none}' +
//         '@media(max-width:767px){#wfw-express-visit img{display:none}}' +
//         '@media(min-width:768px){#wfw-express-visit{display:none}}';
//       document.head.appendChild(style);
//     }
//     var mark = document.querySelector('.w-express-toggle__mark');
//     var src = mark ? mark.getAttribute('src') : '';
//     var chip = document.createElement('div');
//     chip.id = 'wfw-express-visit';
//     chip.setAttribute('role', 'status');
//     chip.innerHTML =
//       '<span>Visit to discover W Express</span>' +
//       (src ? '<img alt="" width="42" height="18" src="' + src.replace(/"/g, '&quot;') + '">' : '') +
//       '<span>products</span>' +
//       '<button type="button" aria-label="Close">&times;</button>' +
//       '<span class="wfw-express-visit__tail" aria-hidden="true"></span>';
//     document.body.appendChild(chip);
//     function placeVisitHint() {
//       var btn = document.querySelector('.bottom-nav-wrapper [data-w-express-nav]');
//       var tail = chip.querySelector('.wfw-express-visit__tail');
//       if (!btn || !tail) return;
//       var rect = btn.getBoundingClientRect();
//       if (window.matchMedia('(min-width: 768px)').matches || rect.width < 1 || rect.height < 1) {
//         chip.style.display = 'none';
//         return;
//       }
//       chip.style.display = '';
//       chip.style.right = 'auto';
//       chip.style.width = 'max-content';
//       chip.style.maxWidth = 'calc(100vw - 24px)';
//       var width = chip.offsetWidth;
//       var center = rect.left + rect.width / 2;
//       var margin = 12;
//       var left = Math.round(center - width / 2);
//       var maxLeft = window.innerWidth - margin - width;
//       if (left < margin) left = margin;
//       if (left > maxLeft) left = Math.max(margin, maxLeft);
//       chip.style.left = left + 'px';
//       chip.style.bottom = Math.round(window.innerHeight - rect.top + 10) + 'px';
//       var tip = Math.round(center - left - 7);
//       if (tip < 12) tip = 12;
//       if (tip > width - 26) tip = width - 26;
//       tail.style.display = 'block';
//       tail.style.left = tip + 'px';
//       tail.style.bottom = '-8px';
//     }
//     placeVisitHint();
//     window.addEventListener('resize', placeVisitHint);
//     function close() {
//       if (chip.parentNode) chip.parentNode.removeChild(chip);
//     }
//     var timer = window.setTimeout(close, 5000);
//     chip.querySelector('button').addEventListener('click', function (event) {
//       event.preventDefault();
//       event.stopPropagation();
//       window.clearTimeout(timer);
//       close();
//     });
//   }

//   function init() {
//     document.addEventListener('click', onExpressClick);
//     document.addEventListener('wfw:express-pin-needed', function () {
//       openModal('header');
//     });
//     document.addEventListener('wfw:express-pin-submit', function (event) {
//       var pin = event && event.detail ? event.detail.pincode : '';
//       window.WfwExpressTrack.pin(pin, 'header');
//       commitPin(pin);
//     });
//     document.addEventListener('keydown', function (event) {
//       if (event.key === 'Escape') closeModal();
//     });
//     trackExpress('user');
//     syncToggleFromPin();
//     showVisitHint();
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }
// })();
// /* WFW EXPRESS NAV END */
